import React from 'react'
import { Box, Typography } from '@mui/material'

interface VerificationLoaderProps {
  isLoading: boolean
  error?: boolean
}

const VerificationLoader: React.FC<VerificationLoaderProps> = ({
  isLoading,
  error,
}) => {
  return (
    <Box
      className="wallet-card-container"
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      {isLoading ? (
        <Typography>Verifying your access...</Typography>
      ) : error ? (
        <Typography>
          Invalid or expired link. Please request a new link to access your
          wallet card.
        </Typography>
      ) : null}
    </Box>
  )
}

export default VerificationLoader
